import { createApp, defineAsyncComponent } from "vue";
import App from './App.vue'
import { createRouter, createWebHistory } from "vue-router";
import './assets/tailwind.css'

const routes = [
    {
      path: "/",
      component: defineAsyncComponent(() =>
        import("./components/main/LandingPage.vue")
      ),
    },
    {
      path: "/what-we-do",
      component: defineAsyncComponent(() =>
        import("./components/main/WhatWeDo.vue")
      ),
    },
    {
      path: "/products",
      component: defineAsyncComponent(() =>
        import("./components/main/Products.vue")
      ),
    },
    {
      path: "/products/:id",
      component: defineAsyncComponent(() =>
        import("./components/main/ProductDetails.vue")
      ),
    },
    {
      path: "/about-us",
      component: defineAsyncComponent(() =>
        import("./components/main/AboutUs.vue")
      )
    },
    {
      path: "/contact-us",
      component: defineAsyncComponent(() =>
        import("./components/main/ContactUs.vue")
      ),
    }
  ];
  const router = createRouter({
    history: createWebHistory(),
    routes: routes,
  });


createApp(App).use(router).mount('#app')
